import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Student } from '../../services/model/student';

export const StudentActions = createActionGroup({
  source: 'Student',
  events: {
    'Students Loaded': props<{ students: Student[] }>(),
    'Reset': emptyProps(),
  },
});